import React from 'react';
import { useInRouterContext, useNavigate } from 'react-router-dom';
import { Button, Tooltip } from '@fluentui/react-components';
import { FolderLink20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

import { AzureFileOwner } from '../../../models/Entities/AzureFiles/AzureFileUpload';
import { buildFilesExplorerUrl, getOwnerFolderPath } from '../../../functions/StorageBrowser.Functions';

export interface ViewInFilesLinkProps {
  /** Storage owner of the upload target (proveedor_45, sponsor_12/protocolo_301, ...) */
  owner: AzureFileOwner | undefined;
  /** Called before navigating (e.g. to close the drawer) */
  onNavigate?: () => void;
}

const ViewInFilesLinkInner = ({ folderPath, onNavigate }: { folderPath: string; onNavigate?: () => void }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Tooltip content={t('filesExplorer.viewInFilesTooltip')} relationship="description" withArrow>
      <Button
        appearance="subtle"
        icon={<FolderLink20Regular />}
        onClick={() => {
          onNavigate?.();
          navigate(buildFilesExplorerUrl(folderPath));
        }}
        data-testid="view-in-files-link"
      >
        {t('filesExplorer.viewInFiles')}
      </Button>
    </Tooltip>
  );
};

/** "Ver en Archivos": opens the explorer on the owner folder. Renders nothing outside a router or without owner. */
export const ViewInFilesLink = ({ owner, onNavigate }: ViewInFilesLinkProps) => {
  const inRouter = useInRouterContext();
  const folderPath = getOwnerFolderPath(owner);
  if (!inRouter || !folderPath) return null;
  return <ViewInFilesLinkInner folderPath={folderPath} onNavigate={onNavigate} />;
};

export default ViewInFilesLink;
